import { LogoColors, LOGO_COLOR_VALUES } from './constants';

export const LogoViewBox = '0 0 48 48';

export type IterableLogoSvgProps = {
  /** The height of the logo */
  height?: number;
  /** The Array of Colors and Opacities for the Logo Fill
   * format - [ [ color, opacity ]x4 ]
   * Defaults to colored logo */
  color: (typeof LOGO_COLOR_VALUES)[0];
};

export const IterableLogoDiamondBordered = ({
  color = LOGO_COLOR_VALUES[LogoColors.COLOR],
  height,
  ...props
}: IterableLogoSvgProps) => (
  <svg
    data-test="logo-svg" // default data-test, overridden by props if one is passed in
    height={height ?? '42'}
    width={height ? undefined : '100%'}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="-2.29289"
      y="21"
      width="33"
      height="33"
      rx="7.5"
      transform="rotate(-45 -2.29289 21)"
      fill="#FDF5FF"
      stroke="#EBD3F1"
    />
    <g clipPath="url(#clip0_10082_15572)">
      <path
        opacity="0.25"
        d="M30.8007 17.7847L17.9644 30.6211L24.4308 37.0875L37.2672 24.2512L30.8007 17.7847Z"
        fill="#59C1A7"
      />
      <path
        opacity="0.25"
        d="M24.3454 4.84215L17.8789 11.3086L30.7153 24.145L37.1817 17.6785L24.3454 4.84215Z"
        fill="#34C3F2"
      />
      <path
        opacity="0.15"
        d="M11.3102 17.7914L4.84375 24.2578L17.6801 37.0942L24.1466 30.6277L11.3102 17.7914Z"
        fill="#EF3D55"
      />
      <path
        opacity="0.15"
        d="M17.9865 4.53863L5.15015 17.375L11.6166 23.8414L24.453 11.0051L17.9865 4.53863Z"
        fill="#6A266D"
      />
      <path
        d="M21.0341 12.5844C23.5783 12.5844 25.6408 10.5219 25.6408 7.97773C25.6408 5.43355 23.5783 3.37109 21.0341 3.37109C18.49 3.37109 16.4275 5.43355 16.4275 7.97773C16.4275 10.5219 18.49 12.5844 21.0341 12.5844Z"
        fill="#6A266D"
      />
      <path
        d="M34.0351 25.643C36.5793 25.643 38.6417 23.5805 38.6417 21.0363C38.6417 18.4921 36.5793 16.4297 34.0351 16.4297C31.4909 16.4297 29.4285 18.4921 29.4285 21.0363C29.4285 23.5805 31.4909 25.643 34.0351 25.643Z"
        fill="#34C3F2"
      />
      <path
        d="M21.0341 38.643C23.5783 38.643 25.6408 36.5805 25.6408 34.0363C25.6408 31.4921 23.5783 29.4297 21.0341 29.4297C18.49 29.4297 16.4275 31.4921 16.4275 34.0363C16.4275 36.5805 18.49 38.643 21.0341 38.643Z"
        fill="#59C1A7"
      />
      <path
        d="M8.03315 25.5922C10.5773 25.5922 12.6398 23.5297 12.6398 20.9855C12.6398 18.4414 10.5773 16.3789 8.03315 16.3789C5.48897 16.3789 3.42651 18.4414 3.42651 20.9855C3.42651 23.5297 5.48897 25.5922 8.03315 25.5922Z"
        fill="#EF3D55"
      />
    </g>
    <defs>
      <clipPath id="clip0_10082_15572">
        <rect width="36" height="36" fill="white" transform="translate(3 3)" />
      </clipPath>
    </defs>
  </svg>
);
